import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import WelcomeComponent from "./welcome/welcome.component";
import ArticlePanelComponent from "./article/article-panel.component";
import DisplayArticleComponent from "./article/display/display-article.component";
import NotFoundComponent from "./not-found/not-found.component";
import DisplayProfileComponent from "./profile/display-profile.component";
import { TypedConnect } from "models/store";
import "./body.component.scss";

@TypedConnect(
  () => {
    return {};
  },
  () => {
    return {};
  }
)
export default class BodyComponent extends Component {
  render() {
    // TODO: add permanent top margin
    return (
      <Container fluid className="App-body content-container">
        <Row className="whole-height-desktop whole-width align-center">
          <Col md={12}>
            {/* TODO: make this column independently scrollable */}
            <Routes>
              <Route path="/" element={<WelcomeComponent />}></Route>
              <Route
                path="/article/*"
                element={<ArticlePanelComponent />}
              ></Route>
              <Route
                path="/posts/:articleID/:slug?"
                element={<DisplayArticleComponent />}
              ></Route>
              <Route
                path="/profile/*"
                element={<DisplayProfileComponent />}
              ></Route>
              <Route path="*" element={<NotFoundComponent />}></Route>
            </Routes>
          </Col>
        </Row>
      </Container>
    );
  }
}
